<template>
  <div class="container">
    <div class="content">
      <h1 class="title has-text-centered mt-4">Project Team</h1>

      <!-- Supervisors Section -->
      <h2 class="subtitle has-text-centered mt-6">Under the Supervision of</h2>
      <div class="columns is-multiline is-centered">
        <div class="column is-one-third">
          <div class="card">
            <div class="card-content">
              <div class="media">
                <div class="media-content has-text-centered">
                  <p class="title is-4">Prof. Supratik Chakraborty</p>
                  <p class="subtitle is-6">Project Supervisor</p>
                  <p>Department of Computer Science and Engineering</p>
                  <p>IIT Bombay</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Developers Section -->
      <h2 class="subtitle has-text-centered mt-6">Development Team</h2>
      <div class="columns is-multiline is-centered">
        <div class="column is-one-third">
          <div class="card">
            <div class="card-content">
              <div class="media">
                <div class="media-content has-text-centered">
                  <p class="title is-4">Ravi Patidar</p>
                  <p class="subtitle is-6">Developer</p>
                </div>
              </div>
              <div class="content">
                <div class="buttons are-small is-centered">
                  <a href="https://www.linkedin.com/in/ravi-patidar-07460b184" class="button is-link">
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Profile</span>
                  </a>
                  <a href="https://www.linkedin.com/in/ravi-patidar-07460b184" class="button is-info">
                    <span class="icon"><i class="fab fa-linkedin"></i></span>
                    <span>LinkedIn</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-one-third">
          <div class="card">
            <div class="card-content">
              <div class="media">
                <div class="media-content has-text-centered">
                  <p class="title is-4">Vishal Kumar Singh</p>
                  <p class="subtitle is-6">Developer</p>
                </div>
              </div>
              <div class="content">
                <div class="buttons are-small is-centered">
                  <a href="https://vishalkumarsingh.com" class="button is-link">
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Profile</span>
                  </a>  
                  <a href="https://www.linkedin.com/in/vishal-kumar-singh-bab818180/" class="button is-info">
                    <span class="icon"><i class="fab fa-linkedin"></i></span>
                    <span>LinkedIn</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-one-third">
          <div class="card">
            <div class="card-content">
              <div class="media">
                <div class="media-content has-text-centered">
                  <p class="title is-4">Reeshabh</p>
                  <p class="subtitle is-6">Developer</p>
                </div>
              </div>
              <div class="content">
                <div class="buttons are-small is-centered">
                  <a href="" class="button is-link">
                    <span class="icon"><i class="fas fa-user"></i></span>
                    <span>Profile</span>
                  </a>
                  <a href="" class="button is-info">
                    <span class="icon"><i class="fab fa-linkedin"></i></span>
                    <span>LinkedIn</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Technologies Section -->
      
    </div>
  </div>
</template>

<style scoped>
.card {
  transition: transform 0.3s;
  height: 100%;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.image.is-1by1 img {
  object-fit: cover;
}
</style>
